import { render } from "./AboutSystem.vue?vue&type=template&id=2077d8cc&ts=true"
import script from "./AboutSystem.vue?vue&type=script&lang=ts"
export * from "./AboutSystem.vue?vue&type=script&lang=ts"

import "./AboutSystem.vue?vue&type=style&index=0&id=2077d8cc&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__